import axios from "axios";

import { BASE_URL } from "libs/data-access/constant";
import { handleFormatResponse, handleFormatResponseForError } from "libs/data-access/utility";


export function useUnsecure() {

    const getUnsecureData = async (endPoint: string) => {
        try {
            let response = await axios.get(`${BASE_URL}unsecure/${endPoint}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const errorResponse = handleFormatResponseForError(error);
            return errorResponse;
        };
    };

    const postUnsecureData = async (endPoint: string, payload?: any) => {
        try {
            let response = await axios.post(`${BASE_URL}unsecure/${endPoint}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const errorResponse = handleFormatResponseForError(error.response);
            return errorResponse;
        };
    };

    const putUnsecureData = async (endPoint: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}unsecure/${endPoint}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const errorResponse = handleFormatResponseForError(error.response);
            return errorResponse;
        };
    };

    const patchUnsecureData = async (endPoint: string, payload: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}unsecure/${endPoint}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const errorResponse = handleFormatResponseForError(error.response);
            return errorResponse;
        };
    };

    return {
        getUnsecureData,
        postUnsecureData,
        putUnsecureData,
        patchUnsecureData
    };

};